import { render, staticRenderFns } from "./NumberRegistration.vue?vue&type=template&id=67b1f096&"
import script from "./NumberRegistration.vue?vue&type=script&lang=js&"
export * from "./NumberRegistration.vue?vue&type=script&lang=js&"
import style0 from "./NumberRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports